import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SpinnerComponent } from '../../../../shared/components/az-spinner/spinner.component';
import { EXTERNAL_URLS } from '../../../../shared/config/external-urls';

@Component({
    selector: 'app-logout',
    imports: [SpinnerComponent],
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.scss'
})
export class LogoutComponent {
  readonly logoUrl = EXTERNAL_URLS.azureLoginBanner;

  constructor(private authService: AuthService) {
    this.authService.logout();
  }
}
